import { BadStatusError } from '@confluence/network';

import type { AudioBriefingErrorType } from '../types/audioBriefingErrorType';
import { AudioBriefingError } from '../types/audioBriefingErrorType';

export const determineErrorType = async (
	error: BadStatusError | Error,
): Promise<AudioBriefingErrorType> => {
	if (error instanceof BadStatusError) {
		try {
			const response = error.response.clone();
			const errorData = await response.json();

			if (errorData.error?.includes('minimum context requirements')) {
				return AudioBriefingError.CONTENT_TOO_SHORT;
			}
		} catch (parseError) {
			// If error doesn't have response, or parsing fails, treat as general-error
		}
	}
	return AudioBriefingError.GENERAL_ERROR;
};
